import { Component, OnInit } from "@angular/core";
import { RacesService } from "./raceServices/races.service";

@Component({
  selector: "app-races",
  templateUrl: "./races.component.html",
  styleUrls: ["./races.component.css"]
})
export class RacesComponent implements OnInit {
  constructor(private racesService: RacesService) {}
  currentBtnStatus: any;
  currentRaceDate: any;

  ngOnInit() {
    this.racesService
      .getActiveClass()
      .valueChanges()
      .subscribe(btnStatus => {
        this.currentBtnStatus = btnStatus;
      });

    this.racesService
      .getRaceDate("2022")
      .valueChanges()
      .subscribe(date => {
        this.currentRaceDate = date;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/races/races.component.ts